<template>
  <v-container class="pa-0 ma-1">
    <p>{{$tf('The files you are trying to upload may contain DICOM files What do you want Idonia to do')}}</p>
    <v-expansion-panel class="elevation-0">
      <v-expansion-panel-content
        :value="selected === 0"
        @input="(e) => {selected = e === true ? 0 : selected}"
      >
        <v-icon
            slot="actions"
            color="primary"
            v-if="selected === 0"
        >
          radio_button_checked
        </v-icon>
        <v-icon
            slot="actions"
            v-else
        >
          radio_button_unchecked
        </v-icon>
        <div slot="header">
          {{$tf('Every DICOM file belongs to the same study or patient, Idonia should group them together in a single study')}}
        </div>
      </v-expansion-panel-content>
      <v-expansion-panel-content
          :value="selected === 1"
          @input="(e) => {selected = e === true ? 1 : selected}"
          v-if="!disableDICOM"
      >
        <v-icon
            slot="actions"
            color="primary"
            v-if="selected === 1"
        >
          radio_button_checked
        </v-icon>
        <v-icon
            slot="actions"
            v-else
        >
          radio_button_unchecked
        </v-icon>
        <div slot="header">
          {{$tf('Each folder belongs to different studies or patients, Idonia should create a different study for each one')}}
        </div>
      </v-expansion-panel-content>
      <v-expansion-panel-content
          :value="selected === 2"
          @input="(e) => {selected = e === true ? 2 : selected}"
      >
        <v-icon
            slot="actions"
            color="primary"
            v-if="selected === 2"
        >
          radio_button_checked
        </v-icon>
        <v-icon
            slot="actions"
            v-else
        >
          radio_button_unchecked
        </v-icon>
        <div slot="header">
          {{$tf('I want to upload the files as they are now, even I won\'t be able to see them as DICOM studies in Idonia Viewer')}}
        </div>
      </v-expansion-panel-content>
      <v-container
        class="checkbox-padding-test"
      >
      <v-checkbox
          hide-details
          v-model="saveOption"
          :label="$tf('Remember my selection')"
      ></v-checkbox>
      </v-container>
    </v-expansion-panel>
  </v-container>
</template>

<script>
  export default {
    name: 'DialogIncludeDICOM',
    data () {
      return {
        selected: 0,
        saveOption: false,
        showHint: true
      }
    },
    props: {
      disableDICOM: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      cancel () {
        return 0
      },
      async accept () {
        if (this.selected >= 0 && this.saveOption === true) {
          await this.$store.dispatch('session/setPreferredDICOMUpload', this.selected)
        }
        return this.selected
      }
    }
  }
</script>

<style scoped>
  /deep/ .expansion-panel__container {
    border-top: 0 !important;
  }
  /deep/ .expansion-panel__header {
    flex-direction: row-reverse;
  }
  /deep/ .expansion-panel__header div {
    margin: 5px;
  }
  /deep/ .checkbox label {
    color: rgba(0,0,0,0.87) !important;

  }
  .checkbox-padding-test {
    padding-left: 29px;
  }

  img {
    max-width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/dialog/types/DialogIncludeDICOM.vue